export default (state: any, action: any) => {
  switch (action.type) {
    case "SET_VIEW_MODE":
      return {
        ...state,
        buildings: state.buildingsCache,
        mode: action.payload.mode,
        options: {
          ...state.options,
          searchString: '',
          searchColumn: 'name',
          sortDirection: 'asc',
          sortColumn: 'name',
        }
      };
    case "SET_BUILDINGS":
      const result = paginateBuildings(state.pagination.currentPage, state.pagination.items, action.payload.buildings);
      return {
        ...state,
        buildings: result.buildings,
        buildingsPaginated: result.buildings,
        buildingsCache: action.payload.buildings,
        pagination: {
          ...state.pagination,
          totalPages: result.totalPages
        }
      };
    case "SEARCH_BUILDINGS":
      return {
        ...state,
        buildings: filterBuildingsSearch(state, action),
        options: {
          ...state.options,
          searchString: action.payload.params.searchString,
          searchColumn: action.payload.params.fieldName,
        },
        pagination: {
          ...state.pagination,
        }
      };
    case "PAGINATE_BUILDINGS":
      const { items, currentPage } = action.payload.params;
      const { buildings, totalPages } = paginateBuildings(currentPage, items, state.buildingsCache);
      return {
        ...state,
        buildings,
        buildingsPaginated: buildings,
        pagination: {
          ...state.pagination,
          currentPage: action.payload.params.currentPage,
          items: action.payload.params.items,
          totalPages
        }
      };
    case "SORT_BUILDINGS":
      return {
        ...state,
        buildings: filterBuildingsSort(state, action),
        options: {
          ...state.options,
          sortDirection: action.payload.params.sortDirection,
          sortColumn: action.payload.params.fieldName,
        }
      };
    default:
      return state;
  }
};

const filterBuildingsSearch = (state: any, action: any) => {
  const { fieldName, searchString } = action.payload.params;
  let { buildingsPaginated } = state;
  if (!searchString) {
    return [...buildingsPaginated];
  }
  return [...buildingsPaginated].filter((item: any) => {
    return covertGermanLetters(item[fieldName]).toLocaleLowerCase().includes(covertGermanLetters(searchString).toLocaleLowerCase());
  });
}

const filterBuildingsSort = (state: any, action: any) => {
  const { fieldName, sortDirection } = action.payload.params;
  let { buildingsPaginated } = state;
  if (!sortDirection) {
    return [...buildingsPaginated];
  }
  return [...buildingsPaginated].sort((a: any, b: any): any => {
    let aField = a[fieldName];
    let bField = b[fieldName];
    if (typeof aField === 'object' && (aField.sortParam || aField.sortParam === 0)) {
      aField = a[fieldName].sortParam;
      bField = b[fieldName].sortParam;
    } else {
      aField = (a[fieldName] || '').toLocaleLowerCase();
      bField = (b[fieldName] || '').toLocaleLowerCase();
    }
    if (sortDirection === 'asc') {
      return aField > bField ? 1 : -1;
    } else if (sortDirection === 'dsc') {
      return bField > aField ? 1 : -1;
    }
    return 1;
  });
}

const covertGermanLetters = (text: string) => {
  // Ü, ü     \u00dc, \u00fc
  // Ä, ä     \u00c4, \u00e4
  // Ö, ö     \u00d6, \u00f6
  // ß        \u00df
  return text.replace(/\u00e4/g, "ae")
  .replace(/\u00c4/g, "ae")
  .replace(/\u00fc/g, "u")
  .replace(/\u00dc/g, "U")
  .replace(/\u00f6/g, "o")
  .replace(/\u00d6/g, "O");
}

const paginateBuildings = (currentPage: any,  items: any, buildingsCache: any) => {
  let totalPages = 1;
  if (! buildingsCache.length) {
    return {buildings: [], totalPages};
  }
  const total = buildingsCache.length;
  totalPages = items === "All" ? 1 : parseInt((total / items).toString()) + (total % items === 0 ? 0 : 1);
  items = items === "All" ? total : items;
  const buildings = paginate(currentPage, items, buildingsCache);
  return {buildings, totalPages};
}

const paginate = (currentPage: number, items: number, array: any) => {
  return array.slice((currentPage - 1) * items, currentPage * items);
}